import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
import RatingAndReviewsPlaceholder from 'components/consumer/RatingAndReviews/RatingAndReviewsPlaceholder';
import PDPPriceAndFinancePlaceholder from './PDPPriceAndFinancePlaceholder';
const PDPNameSectionPlaceholder = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-row items-center"><h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10"><Placeholder type="rect" loading={true} className="!w-full lg:!w-[310px]" style={{
          height: "23px"
        }} /></h1></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0"><RatingAndReviewsPlaceholder /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t0}{t1}<div className="bg-white pt-4 px-0 pb-3 sticky top-0 z-[999] lg:z-[1001] lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0"><PDPPriceAndFinancePlaceholder /></div></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default PDPNameSectionPlaceholder;